export enum UpdateAccountFieldName {
  None = 0,
  Status = 1,
  BgColorHex = 2,
  TextColorHex = 3,
}
